import React from "react"
import PropTypes from "prop-types"
import { useFormik } from "formik"

import { emailRegexp, encode } from "../../utilities/functions"
import Arrow from "../arrow/arrow"
import Multilinguist from "../svg/multilinguist"
import { SelectInput } from "../selectInput/selectInput"
import "./enroll.scss"

export function validate(values) {
  const errors = {}
  const requiredMessage = "Поле не может быть пустым"

  if (!values.ename) {
    errors.ename = requiredMessage
  }
  if (!values.esurname) {
    errors.esurname = requiredMessage
  }

  if (!values.eemail) {
    errors.eemail = requiredMessage

  } else if (!emailRegexp.test(values.eemail)) {
    errors.eemail = "Неверный e-mail адрес"

  }

  if (!values.eagree) {
    errors.eagree = "Мы не можем записать Вас без разрешения на обработку ваших данных"
  }

  if (!values.elang) {
    errors.elang = "Пожалуйста, выберите язык"
  }
  if (!values.elevel) {
    errors.elevel = "Пожалуйста, выберите ваш уровень знания языка"
  }
  return errors
}

const Enroll = ({ closeModal }) => {
  const handleSubmit = values => {
    console.log("enroll submit: ", encode({ "form-name": "enroll", ...values }))
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "enroll", ...values })
    })
      .then(() => {
        closeModal()
        alert("Спасибо, мы обязательно свяжемся с вами!")
      })
      .catch(error => alert(error))
  }
  const formik = useFormik({
    initialValues: {
      ename: "",
      esurname: "",
      eemail: "",
      ephone: "",
      esocials: "",
      elang: "",
      elevel: "",
      eagree: false
    },
    validate,
    onSubmit: handleSubmit
  })

  const optionsLang = [
    { value: "", label: "Выберите язык" },
    { value: "fr", label: "Французский язык" },
    { value: "en", label: "Английский язык" },
    { value: "it", label: "Итальянский язык" },
    { value: "es", label: "Испанский язык" },
    { value: "pt", label: "Португальский язык" }
  ]

  const optionsLevel = [
    { value: "", label: "Ваш уровень знания языка" },
    { value: "0", label: "С нуля" },
    { value: "a1", label: "А1" },
    { value: "a2", label: "А2" },
    { value: "b1", label: "B1" },
    { value: "b2", label: "B2" },
    { value: "c1", label: "C1" },
    { value: "c2", label: "C2" },
    { value: "idk", label: "Я не знаю" }


  ]

  return (
    <form
      onSubmit={formik.handleSubmit}
      name="enroll"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      className="enroll question-wrapper"
    >
      <input
        type="hidden"
        name="form-name"
        value="enroll"
      />
      <div className="enroll__column enroll__left-column">
        <div className="enroll__input-wrapper">
          <div className="question__warning first--warning">
            {
              formik.touched.ename && formik.errors.ename
                ? formik.errors.ename
                : null
            }
          </div>
          <input
            type="text"
            id="ename"
            name="ename"
            value={formik.values.ename}
            placeholder="Имя"
            {...formik.getFieldProps("ename")}
            className="enroll__input enroll__left-input"
            required
          />
        </div>
        <div className="enroll__input-wrapper">

          <div className="question__warning first--warning">
            {
              formik.touched.esurname && formik.errors.esurname
                ? formik.errors.esurname
                : null
            }
          </div>
          <input
            type="text"
            id="esurname"
            name="esurname"
            value={formik.values.esurname}
            placeholder="Фамилия"
            {...formik.getFieldProps("esurname")}
            className="enroll__input enroll__left-input"
            required
          />
        </div>
        <div className="question__img enroll__img">
          <Multilinguist />
        </div>
      </div>
      <div className="enroll__column">

        <div className="enroll__input-wrapper">

          <div className="question__warning first--warning">
            {
              formik.touched.eemail && formik.errors.eemail
                ? formik.errors.eemail
                : null
            }
          </div>
          <input
            type="email"
            id="eemail"
            name="eemail"
            title="Please enter your e-mail"
            value={formik.values.eemail}
            placeholder="e-mail"
            {...formik.getFieldProps("eemail")}
            className="enroll__input"
            required
          />
        </div>

        <input
          type="number"
          id="ephone"
          name="ephone"
          value={formik.values.ephone}
          placeholder="Номер телефона"
          {...formik.getFieldProps("ephone")}
          className="enroll__input"

        />

        <input
          type="text"
          id="esocials"
          name="esocials"
          value={formik.values.esocials}
          placeholder="Альтернативный способ связи (FB, IG, Telegram и т.д.)"
          {...formik.getFieldProps("esocials")}
          className="enroll__input"

        />
        <div className="enroll__input-wrapper">

          <div className="question__warning first--warning">
            {
              formik.touched.elang && formik.errors.elang
                ? formik.errors.elang
                : null
            }
          </div>
          <SelectInput
            options={optionsLang}
            value={formik.values.elang}
            onChange={value => formik.setFieldValue("elang", value)}
            required
          />
        </div>
        <div className="enroll__input-wrapper">

          <div className="question__warning first--warning">
            {
              formik.touched.elevel && formik.errors.elevel
                ? formik.errors.elevel
                : null
            }
          </div>
          <SelectInput
            options={optionsLevel}
            value={formik.values.elevel}
            onChange={value => formik.setFieldValue("elevel", value)}
          />
        </div>
        <div className="enroll__input-wrapper">

          <div className="question__warning first--warning checkbox--warning">
            {
              formik.touched.eagree && formik.errors.eagree
                ? formik.errors.eagree
                : null
            }
          </div>
          <div className="enroll__checkbox-wrapper">
            <input
              type="checkbox"
              id="eagree"
              name="eagree"
              value={formik.values.eagree}
              {...formik.getFieldProps("eagree")}
              className="enroll__input enroll__checkbox"
              required
            />
            <label htmlFor="eagree">Я ознакомился и согласен с
              <a href="https://allacroix.netlify.app/agreement"
                 rel="noreferrer"
                 target="_blank">
                условиями обработки и
              хранения моих
              персональных
              данных</a>.</label>
          </div>

        </div>
        <button
          type="submit"
          className="button submit"
        >
          <h4>ОТПРАВИТЬ</h4>
          <Arrow direction="right" />
        </button>
      </div>
    </form>
  )
}

Enroll.propTypes =
  {
    closeModal: PropTypes.func
  }

Enroll.defaultProps =
  {
    closeModal: () => {
      alert(`Oops, something went wrong! Please reload the page to close modal window`)
      console.error("No closeModal function provided")
    }
  }
export default Enroll
